import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Avatar, Row, Col, DatePicker } from 'antd';
import { Link } from 'react-router-dom';
import moment from "moment/moment";
import Tab from '../Tab';
import Layout from '../Layout';
import CatFilterList from '../Categories/components/CatFilterList';
import CategoriesList from '../Categories/components/CategoriesList';
import TypeFilterList from '../Types/components/TypeFilterList';
import ErrorAlert from '../../components/ErrorAlert';
import { get, remove, resetState } from '../../modules/cards';
import { get as getCategories } from '../../modules/categories';
import { get as getTypes } from '../../modules/types';
import IsApproved from '../../components/IsApproved';

const { RangePicker } = DatePicker

class CardsTab extends Tab {

  state = {
    ...this.state,
    isFilter: {
      categories: false,
      types: false,
    },
  };

  columns = this.renderColumns();

  renderColumns() {
    return [
      { key: 'id', title: 'ID', dataIndex: 'id' }, {
        key: 'name',
        title: 'Name',
        dataIndex: 'name',
        width: 400,
        render: (name, data) => {
          return (
            <Fragment>
              <Avatar
                size="large"
                src={data.logo}
                className="mr-1"
              />
              <Link to={`cards/${data.id}`}>{name}</Link>
            </Fragment>
          );
        },
      }, {
        key: 'categories',
        title: 'Categories',
        dataIndex: 'categories',
        className: 'cat-list-filter',
        render: (cat_name, data) => {
          return <CategoriesList catArray={data.categories}
                                 updateFilter={this.updateFilter('categories')}
                                 className="mb-minus-1"
          />;
        },
      }, {
        key: 'types',
        title: 'Types',
        dataIndex: 'types',
        className: 'type-list-filter',
        render: (type_name, data) => {
          return data.types.map(type => (
            <span key={type.id}
                  onClick={this.updateFilter('types')(type.id)}
                  className="tag bordered cursor-pointer">
              {type.name}
            </span>
          ));
        },
      }, {
        key: 'approved',
        title: 'Status',
        dataIndex: 'approved',
        render: (name, data) => <IsApproved isApproved={data.approved} />,
      }, {
        key: 'created_at_range',
        title: 'Created At',
        dataIndex: 'created_at',
        render: (created_at) => <span>{created_at ? moment(created_at).format('DD MMM Y, hh:mm A') : ''}</span>,
        sorter: true,
        filterDropdown: (props) => {
          const { setSelectedKeys, selectedKeys, confirm } = props;

          const defaultValue = Array.isArray(selectedKeys) && selectedKeys.length === 2
            ? selectedKeys.map(d => moment(d))
            : undefined

          return (
            <RangePicker
              defaultValue={defaultValue}
              ranges={{
                Today: [moment().startOf('day'), moment().endOf('day')],
                Yesterday: [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                'This Week': [moment().startOf('week'), moment().endOf('week')],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
              }}
              onChange={(range) => {
                range.length
                  ? setSelectedKeys([range[0].format(), range[1].format()])
                  : setSelectedKeys([]);
                confirm();
              }}
            />
          );
        }
      },
      this.tableActions(),
    ];
  }

  componentWillMount() {
    super.componentWillMount();
    this.props.getCategories();
    this.props.getTypes();
  }

  onParamsParseDone(state) {
    this.parseQuerySort(state, this.columns, 5);

    const createdAtFilter = state.filter && state.filter.created_at_range;
    if (createdAtFilter) {
      this.columns[5].defaultFilteredValue = createdAtFilter;
    }
  }

  updateFilter = name => (value) => () => {
    let { filter, page, isFilter } = this.state;

    if (!filter[name]) {
      filter[name] = [];
    }

    if (!filter[name].includes(value)) {
      filter[name].push(value);
      page.number = 0;

      this.setState({
        filter,
        page,
        isFilter: { ...isFilter, [name]: true },
      }, () => {
        this.getData();
        this.addParamsToUrl();
      });
    }

  };

  clearFilter = name => (value) => (e) => {
    e.stopPropagation();

    const { filter, isFilter } = this.state;

    if (filter[name].includes(value)) {
      filter[name] = filter[name].filter(item => item !== value);

      this.setState({ ...this.state, filter }, () => {
        this.getData();
        this.addParamsToUrl();
      });

      if (filter[name].length === 0) {
        this.setState({
          ...this.state,
          isFilter: { ...isFilter, [name]: false },
        });
      }
    }

    if (!value) {
      this.setState({
        ...this.state,
        filter: { ...filter, [name]: [] },
        isFilter: { ...isFilter, [name]: false },
      }, () => {
        this.getData();
        this.addParamsToUrl();
      });
    }
  };

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error} />
        <Row>
          <Col>
            {this.renderFiltersBlock(this.renderSearchInput('search', 'search'))}
          </Col>
        </Row>
        <Row>
          <Col>
            <CatFilterList catArray={this.props.categories.data.results}
                           selectedCatArray={this.state.filter.categories}
                           updateFilter={this.updateFilter('categories')}
                           clearFilter={this.clearFilter('categories')}
                           isFilter={this.state.isFilter.categories || this.props.location.search.includes(
                             'categories')}
            />
            <TypeFilterList typesArray={this.props.types.data.results}
                            selectedTypesArray={this.state.filter.types}
                            updateFilter={this.updateFilter('types')}
                            clearFilter={this.clearFilter('types')}
                            isFilter={this.state.isFilter.types || this.props.location.search.includes(
                              'types')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            {this.renderDataTable()}
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.cards,
    categories: state.categories,
    types: state.types,
  }),
  {
    get, remove, resetState, getCategories, getTypes,
  })(CardsTab);




// WEBPACK FOOTER //
// ./src/containers/Cards/CardsTab.js